import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const WeddingPlanner = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my wedding planner business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps wedding planner businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for wedding planner businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most wedding planner businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my wedding planner business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like wedding planner. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Wedding Planner - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Wedding Planner CRM", url: "/industries/wedding-planner" }
  ];

  const industryData = {
    name: 'Wedding Planner',
    title: 'Book More Weddings & Manage Events Without the Stress',
    subtitle: 'Capture inquiries instantly, automate client communications, and coordinate vendors without constant phone calls',
    icon: '💍',
    challenges: [
      'Missing inquiries while at events',
      'Too much back-and-forth with couples',
      'Vendor coordination takes forever',
      'Hard to get deposits and final payments',
      'Timeline management is chaotic'
    ],
    solutions: [
      'Inquiry capture with instant portfolio links',
      'Automated questionnaire and detail collection',
      'Vendor coordination portal',
      'Payment milestone automation',
      'Timeline and checklist automation'
    ],
    features: [
      'Client CRM with wedding details',
      'Automated client questionnaires',
      'Vendor coordination system',
      'Payment tracking',
      'Timeline automation',
      'Contract management',
      'Mood board sharing',
      'Review automation'
    ],
    results: [
      'Book 60% more weddings',
      '80% reduction in coordination calls',
      'Manage 3x more events simultaneously',
      '£7.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Wedding Planner UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for wedding planner businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for wedding planner UK, wedding planner business software, wedding planner customer management, wedding planner lead generation UK"
        url="/industries/wedding-planner"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default WeddingPlanner;